import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasAMPIMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('AMPI_MEMBER_CENTER');
    }
}
